import { Button, Col, Input, Row, Form, notification, Result } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import { EMAIL_PATTERN } from "../../config/constant";
import { forgotPasswordApi } from "../../config/Api";
import { apiErrorMessage } from "../../services/ApiError";
import "./style/ForgetPassword.scss";

export const ForgetPassword = () => {
    const [loading, setLoading] = useState(false)
    // message shown after the request; the backend gives the same answer whether or not the email exists
    const [sentMessage, setSentMessage] = useState('')

    const onFinish = (values) => {
        setLoading(true)
        forgotPasswordApi(values.email.trim())
            .then((res) => {
                setSentMessage(res.data.message)
            })
            .catch((err) => {
                notification.error({
                    message: apiErrorMessage(err),
                })
            })
            .finally(() => setLoading(false))
    }
    return (
        <div className="ForgetPassword">
            <Form
                name="loginForm"
                className="ForgetPasswordForm"
                onFinish={onFinish}
            >
                <div className="logoSection">
                    <h2 className="mb-0">Nutri Nexus</h2>
                </div>
                <Row justify="center">
                    <Col xs={24} md={16} xl={11} xxl={{ span: 7 }} className="rightForm">
                        <div id="ForgotPasswordFormContent" className="p-4 rounded">
                            {sentMessage ? (
                                <Result
                                    status="success"
                                    title="Check your email"
                                    subTitle={`${sentMessage} The link is valid for 60 minutes.`}
                                    extra={<Link to="/">Back to login</Link>}
                                />
                            ) : (
                                <>
                                    <h4 className="text-center login-title">
                                        Reset Password
                                    </h4>
                                    <label className="form-input-label">
                                        Email Address:
                                    </label>
                                    <Form.Item
                                        name="email"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please insert Email!",
                                            },
                                            {
                                                pattern: EMAIL_PATTERN,
                                                message: "Please insert valid data!",
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Enter Email" className="mt-2 p-2" />
                                    </Form.Item>
                                    <Button htmlType="submit" block loading={loading} className="submit-button border-0 rounded">
                                        Send Password Reset Link
                                    </Button>
                                    <div className="text-center mt-3">
                                        <Link to="/">Back to login</Link>
                                    </div>
                                </>
                            )}
                        </div>
                    </Col>
                </Row>
            </Form>
        </div >
    )
}
